import { Divider } from 'components/commons/Divider'
import { Link } from 'components/commons/Link'
import Page from 'components/Page'
import { useTranslations } from 'next-intl'
import { ReactNode } from 'react'

type DocPageProps = {
  group: string
  title: string
  metadata: { title: string, description: string }
  next?: { name: string, to: string }
  previous?: { name: string, to: string }
  children: ReactNode
}


const DocPage = ({ group, title, metadata, next, previous, children }: DocPageProps) => {

  const t = useTranslations('layout/features')

  return (
    <Page title={metadata.title} description={metadata.description} className='md:pt-32 lg:pl-12'>
      <div>
        <label className='text-blue text-md font-bold'>{group}</label>
        <h1 className='text-4xl font-semibold mt-4'>{title}</h1>
        {children}
        <Divider variant='secondary' className='mt-8 mb-4' />
        <div className='grid gap-4 md:grid-cols-2'>
          <div>
            {previous &&
              <div className='text-left md:text-left'>
                <div >
                  <label className='font-extrabold text-sm'>{t("previous")}</label>
                </div>
                <Link
                  href={previous.to}
                  className='hover:text-blue'
                >
                  <label className='text-md font-extrabold tracking-wider ml-2 '>{'< '} {previous.name}</label>
                </Link>
              </div>
            }
          </div>
          <div>
            {next &&
              <div className='text-right'>
                <div>
                  <label className='font-extrabold text-sm'>{t("next")}</label>
                </div>
                <Link href={next.to}>
                  <label className='text-md font-extrabold tracking-wider mr-2 hover:text-blue'>{next.name} {' >'} </label>
                </Link>
              </div>
            }
          </div>
        </div>
      </div>
    </Page >
  )
}

export default DocPage
